export default __webpack_public_path__ + "static/media/user.76a001d0.png";